var _rect, _path, _path2, _polyline, _polyline2, _line, _line2, _polyline3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXenonFlashLamp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Xenon Flash Lamp") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.35,6.59H3.58c-.88,0-1.51,1.21-1.51,2.72S2.7,12,3.58,12H8.35",
    transform: "translate(-0.25 -0.25)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.1,12h4.78c.88,0,1.51-1.2,1.51-2.71s-.75-2.72-1.51-2.72H8.1",
    transform: "translate(-0.25 -0.25)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "3.96 10.27 3.96 9.05 3.96 7.84",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "11.88 10.27 11.88 9.05 11.88 7.84",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 3.96,
    y1: 9.05,
    y2: 9.05,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 11.88,
    y1: 9.05,
    x2: 16,
    y2: 9.05,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    points: "4.96 6.33 5.84 6.33 5.84 11.78 4.96 11.78 4.96 4.22",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXenonFlashLamp);
export default __webpack_public_path__ + "static/media/XenonFlashLamp.052a895ac8de82d0c26c5dd5349ff2e0.svg";
export { ForwardRef as ReactComponent };